import { render, staticRenderFns } from "./HistoryCardV2.vue?vue&type=template&id=beefd3a4&scoped=true"
import script from "./HistoryCardV2.vue?vue&type=script&lang=js"
export * from "./HistoryCardV2.vue?vue&type=script&lang=js"
import style0 from "./HistoryCardV2.vue?vue&type=style&index=0&id=beefd3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beefd3a4",
  null
  
)

export default component.exports